// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconElectricDividerLeft: React.FC<{ width?: number; height?: number }> = ({ width, height = 16 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="339" height="16" viewBox="0 0 339 16">
            <polyline
                fill="none"
                stroke="currentColor"
                points="0 8.05 256.587 8.05 260.608 15 268.708 1 276.809 15 284.909 1 288.959 8 339 8.05"
            />
        </svg>
    );
};

export default React.memo(IconElectricDividerLeft);
